import { CircularProgress } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import React, { useState } from "react";
import TextError from "../../../Components/HealthInsFormikComponent/TextError";
import DobCKYC from "./DobCKYC";
import CryptoJS from "crypto-js";
import axios from "axios";
import * as Yup from "yup";
import Swal from "sweetalert2";
import PaymentRedirectForm from "../Utilities/PaymentRedirectForm";
import { CREATE_QUOTE_PAGE_ROUTE } from "../../../HealthInsuranceNew/routes";
import isNewProduct from "../../../HealthInsuranceNew/CreateQuote/Helpers/isNewProduct";
import { getLocalData } from "../../../Utilities/Common/source";
import axiosInstance from "../../../Utilities/djangoAxiosInstance";

const careReqCKYC = {
  getCkycEkycInputIO: {
    panNum: "DNJPS0097E",
    document_type: "PAN",
    id_number: "",
    consent_purpose: "this is a consent purpose string pass anything",
    dob: "1991-01-08",
  },
};

const FormCKYC = (props) => {
  const {
    setCKYC,
    CKYC,
    EKYC,
    setEKYC,
    setNext,
    decryptedResponseId,
    decryptedProductRef,
    a_id,
  } = props;
  const [submitForm, setSubmitForm] = useState(false);
  const { productId } = useParams();
  const navigate = useNavigate();
  const productIdArray = productId.split("*");
  const productRef = productIdArray[0];
  const responseId = productIdArray[1];
  const Acuvisor_product_id = productIdArray[2];
  const productRefURI = decodeURIComponent(productRef).toString();
  const responseIdURI = decodeURIComponent(responseId).toString();
  const Acuvisor_product_idURI =
    decodeURIComponent(Acuvisor_product_id).toString();

  const bytesProductRefURI = CryptoJS.AES.decrypt(
    productRefURI,
    "secret key @123"
  );

  const bytesAcuvisor_product_idURI = CryptoJS.AES.decrypt(
    Acuvisor_product_idURI,
    "secret key @124"
  );

  const decryptedAcuvisor_product_id = JSON.parse(
    bytesAcuvisor_product_idURI.toString(CryptoJS.enc.Utf8)
  );

  let encryptedProduct_ref = CryptoJS.AES.encrypt(
    JSON.stringify(decryptedProductRef),
    "secret key @123"
  ).toString();
  let e64_ProdRef = CryptoJS.enc.Base64.parse(encryptedProduct_ref);
  let encryptHexaProdRef = e64_ProdRef.toString(CryptoJS.enc.Hex);

  let encryptedDataId = CryptoJS.AES.encrypt(
    JSON.stringify(decryptedResponseId),
    "secret key @124"
  ).toString();
  let e64_Dataid = CryptoJS.enc.Base64.parse(encryptedDataId);
  let encryptHexaDataId = e64_Dataid.toString(CryptoJS.enc.Hex);

  const localSource = getLocalData("source");
  console.log("FormCKYC localSource: ", localSource);

  const initialValues = {
    panNo: "",
    dob: "",
    mobNo: "",
    userEmail: "",
  };

  const validationSchema = Yup.object().shape({
    panNo: Yup.string()
      .required("Pan Number Required")
      .matches(
        /([A-Z]){5}([0-9]){4}([A-Z]){1}$/,
        "Please Give valid Pan Number"
      )
      .min(10, "Pan Number must have 10 digits")
      .max(10, "Pan Number must not exceed 10 digits"),
    // dob: Yup.string().required("Date of Birth Required"),
    ...(localSource !== "b2c"
      ? {
        mobNo: Yup.string()
          .required("Mobile number is Required")
          .min(10, "Mobile Number must be at least 10 characters")
          .max(10, "Mobile Number must be at most 10 characters"),
        userEmail: Yup.string()
          .required("User Email is Required")
          .matches(
            /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
            "Please Give valid user email id"
          ),
      }
      : {}),
  });

  const onSubmit = async (data) => {
    let domain = "";

    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_FRONT_END;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_FRONT_END;
    } else {
      domain = process.env.REACT_APP_UAT_FRONT_END;
      // domain = "http://192.168.1.6:8000";
    }
    let returnURL = `${domain}/health-insurance/hdfc-kyc-redirect/${encryptHexaProdRef}*${encryptHexaDataId}`;
    console.log("return", returnURL);

    console.log("sub", data);
    console.log(`${returnURL}`);
    setSubmitForm(true);
    let req = {
      ...careReqCKYC,
      getCkycEkycInputIO: {
        ["PAN"]: data.panNo,
        ["DOB"]: '12/31/1997',
        // ["DOB"]: data.dob,
        ["Url"]: returnURL,
        ["mobNo"]: data.mobNo,
        ["userEmail"]: data.userEmail,
      },
    };

    console.log("req", req);

    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
      // domain = "http://192.168.1.6:8000";
    }

    // await axios.post(`${domain}/api/health-insurance/care/ckyc/${decryptedAcuvisor_product_id}/${decryptedResponseId}/`, JSON.stringify(req)).then(
    await axiosInstance
      .post(
        `api/hdfc/kyc/Fetch/${a_id}/${decryptedResponseId}`,
        JSON.stringify(req),
        {
          params: {
            source: localSource,
          }
        }
      )
      .then((response) => {
        // if (response.data.iskycVerified===0){console.log("Hello World")}
        if (
          response.data.fetch.data.iskycVerified === 1 &&
          response.data.verify.data.status === "approved"
        ) {
          console.log("Succes");
          Swal.fire({
            icon: "success",
            // title: `${response.data.data.iskycVerified}`,
            title: "Your KYC is Verified",
            text: "Click on OK button to proceed",
            text: `Your KYC_id is: ${response.data.fetch.data.kyc_id} ,Please Click on OK button to proceed`,
            position: "center",

            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              // getPaymentWithChecksum();
              setSubmitForm(false);
              setNext(false);
              if (
                decryptedAcuvisor_product_id === 55032301 ||
                decryptedAcuvisor_product_id === 55032302
              ) {
                navigate(
                  `/health-insurance/product/${encodeURIComponent(
                    encryptedProduct_ref
                  )}*${encodeURIComponent(encryptedDataId)}`
                );
              } else if (isNewProduct(decryptedAcuvisor_product_id)) {
                navigate(
                  `${CREATE_QUOTE_PAGE_ROUTE}/${encodeURIComponent(
                    encryptedDataId
                  )}/${encodeURIComponent(Acuvisor_product_id)}`
                );
              } else {
                navigate(
                  `/health-insurance/product-stastus/${decryptedResponseId}`
                );
              }
            }
          });
        } else if (
          response.data.fetch.data.iskycVerified === 0 &&
          response.data.verify.data.status === "pending for verification"
        ) {
          Swal.fire({
            icon: "warning",
            // title: `${response.data.data.iskycVerified}`,
            title: "Your KYC iS Pending for Verification",
            text: `Your KYC_id is: ${response.data.fetch.data.kyc_id} ,Please Click on Next button to proceed`,
            // text: 'Click on Next button to proceed',
            position: "center",

            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              setSubmitForm(false);
            }
          });
        } else {
          console.log("Go for KYC");
          Swal.fire({
            icon: "error",
            // title: `${response.data.data.iskycVerified}`,
            title: "Your KYC has Failed",
            text: "Click on Next button to proceed",
            footer: `<a href="${response.data.fetch.data.redirect_link}">Please Click on This Link to complete your KYC`,
            position: "center",

            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              setSubmitForm(false);
            }
          });
        }
        console.log(response.data.fetch.data.redirect_link);
        console.log("response", response);
      })
      .catch((error, response) => {
        if (error.response.status === 400) {
          let errMSG = "";
          if (Array.isArray(error.response.data.message)) {
            errMSG = error.response.data.message[0].errDescription;
          } else {
            errMSG = error.response.data.message;
          }
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${errMSG}`,
            position: "center",
            showConfirmButton: true,
            confirmButtonText: "Do EKYC",
            showCancelButton: true,
            cancelButtonText: "Re-Enter PAN",
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              setCKYC(false);
              setEKYC(true);
              setSubmitForm(false);
            } else if (result.dismiss === "cancel") {
              setSubmitForm(false);
              setCKYC(true);
              setEKYC(false);
            }
            console.log(result, "ff");
          });
          // alert()
          setCKYC(true);
          setEKYC(false);
        }
        console.log("err", error.response);
      });
  };
  const getPaymentWithChecksum = () => {
    let domain = "";


    axiosInstance
      .post(
        `api/hdfc-payment/${decryptedProductRef}/${decryptedResponseId}/null/`
      )
      .then((response) => {
        if (response.status === 200) {
          console.log("Get Checksum", response.data);
          const Checksum = response.data;

          navigate(`/health-insurance/product-stastus/${decryptedResponseId}`);
        }
      })
      .catch((e) => {
        alert(
          "Service is Unavailable at the Moment,\nPlease try after sometime."
        );
      });
  };

  return (
    <div>
      {CKYC && (
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {(formik) => (
            <Form>
              {console.log("formik", formik)}
              <div className="form-container ">
                <div className="d-flex justify-content-center">
                  <h3>Individual Search CKYC</h3>
                </div>
                <div className="form-group  " style={{ paddingTop: "20px" }}>
                  <label
                    htmlFor="panNo"
                    className="fw-light"
                    style={{ paddingBottom: "8px" }}
                  >
                    Pan Number
                    <span class="text-red-500 text-lg">*</span>
                  </label>
                  <div className="input-icons">
                    <Field
                      type="text"
                      name="panNo"
                      id="panNo"
                      className={
                        formik.touched.panNo && formik.errors.panNo
                          ? " errorStyle form-control bg-white"
                          : !formik.errors.panNo && formik.touched.panNo
                            ? " successField form-control bg-white"
                            : " form-control bg-white"
                      }
                    />
                  </div>
                  <ErrorMessage name="panNo" component={TextError} />
                </div>
                <div
                  className="form-group mb-3 "
                  style={{ paddingTop: "20px" }}
                >
                  <label
                    htmlFor="dob"
                    className="fw-light"
                    style={{ paddingBottom: "8px" }}
                  >
                    Date of Birth
                  </label>
                  <div className="input-icons">
                    <Field
                      type="text"
                      name="dob"
                      id="dob"
                      className={
                        formik.touched.dob && formik.errors.dob
                          ? " errorStyle form-control bg-white"
                          : !formik.errors.dob && formik.touched.dob
                            ? " successField form-control bg-white"
                            : " form-control bg-white"
                      }
                      component={DobCKYC}
                    />
                  </div>
                  {/* <ErrorMessage name="dob" component={TextError} /> */}
                </div>
                {localSource !== "b2c" && (
                  <div>
                    <div
                      className="form-group  "
                      style={{ paddingTop: "20px" }}
                    >
                      <label
                        htmlFor="mobNo"
                        className="fw-light"
                        style={{ paddingBottom: "8px" }}
                      >
                        Mobile Number
                        <span class="text-red-500 text-lg">*</span>
                      </label>
                      <div className="input-icons">
                        <Field
                          type="number"
                          name="mobNo"
                          id="mobNo"
                          className={
                            formik.touched.mobNo && formik.errors.mobNo
                              ? " errorStyle form-control bg-white"
                              : !formik.errors.mobNo && formik.touched.mobNo
                                ? " successField form-control bg-white"
                                : " form-control bg-white"
                          }
                        />
                      </div>
                      <ErrorMessage name="mobNo" component={TextError} />
                    </div>
                    <div
                      className="form-group  "
                      style={{ paddingTop: "20px" }}
                    >
                      <label
                        htmlFor="userEmail"
                        className="fw-light"
                        style={{ paddingBottom: "8px" }}
                      >
                        User Email Id
                        <span class="text-red-500 text-lg">*</span>
                      </label>
                      <div className="input-icons">
                        <Field
                          type="text"
                          name="userEmail"
                          id="userEmail"
                          className={
                            formik.touched.userEmail && formik.errors.userEmail
                              ? " errorStyle form-control bg-white"
                              : !formik.errors.userEmail &&
                                formik.touched.userEmail
                                ? " successField form-control bg-white"
                                : " form-control bg-white"
                          }
                        />
                      </div>
                      <ErrorMessage name="userEmail" component={TextError} />
                    </div>
                  </div>
                )}

                <div className="mt-3">
                  {!submitForm ? (
                    <button
                      className="submitBtn text-capitalize "
                      type="submit"
                    //disabled={formik.isSubmitting}
                    >
                      Submit
                    </button>
                  ) : (
                    <div className="d-flex justify-content-center">
                      <CircularProgress
                        size={48}
                        sx={{
                          color: "red",
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default FormCKYC;
